import { Alert, AlertDescription, AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, AlertTitle, Badge, Box, Button, Checkbox, Code, Divider, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, FormControl, FormErrorMessage, FormHelperText, FormLabel, GridItem, HStack, Heading, Icon, IconButton, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Select, SimpleGrid, Skeleton, Spinner, Table, Tbody, Td, Text, Th, Thead, Tr, VStack, useColorModeValue, useDisclosure, useToast } from "@chakra-ui/react";
import StationsApi from "Api/StationsApi";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import { Field, Form, Formik } from "formik";
import Helper from "Helpers/Helper";
import { useLoading } from "Providers/LoadingProvider";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { FaChartLine, FaDatabase, FaExternalLinkAlt, FaHistory, FaList, FaPencilAlt, FaPlusCircle, FaSave, FaSearch, FaTable, FaTrashAlt } from "react-icons/fa";

import { TbAntenna } from "react-icons/tb";
import { Pagination } from 'react-laravel-paginex';
import SingleMarkerMap from "views/Components/SingleMarkerMap";
import 'views/Components/pagination.css';
import ReactJson from 'react-json-view'
import moment from "moment/moment";

function Stations() {
    const [page, setPage] = useState(1);
    const [data, setData] = useState({});
    const loading = useLoading();
    const [filter, setFilter] = useState('');
    const createClosure = useDisclosure();

    const getData = async (param) => {
        loading.show();
        let currentPage = param ? param.page : (page || 1);
        setPage(currentPage);
        let response = await StationsApi.list(currentPage, filter);
        setData(response.json);
        loading.hide();
    }

    useEffect(() => {
        getData();
    }, [filter]);

    const onFilterSubmit = (formData) => {
        setPage(1);
        setFilter(formData.filter);
    }

    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");

    return (
        <>
            <Box bg={cardBg} borderRadius="xl" overflow="hidden" boxShadow="md" border="1px solid" borderColor={borderColor}>
                <Box bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)" py={5} px={6}>
                    <Flex align="center" gap={3}>
                        <Flex align="center" justify="center" bg="whiteAlpha.200" borderRadius="lg" p={2}>
                            <Icon as={TbAntenna} color="white" boxSize={5} />
                        </Flex>
                        <Box flex="1">
                            <Text color="white" fontWeight="bold" fontSize="xl">Estações</Text>
                            <Text color="whiteAlpha.800" fontSize="sm">Painel Administrativo</Text>
                        </Box>
                        <Button onClick={createClosure.onOpen} leftIcon={<FaPlusCircle />} colorScheme="whiteAlpha" color="white" variant="solid" fontSize="md">
                            Nova
                        </Button>
                    </Flex>
                </Box>
                <Box p={6}>
                    <Flex direction="column" w="100%">
                        <Flex direction="column" w="100%" overflowX={"auto"} mb={4}>
                            <Formik onSubmit={onFilterSubmit} initialValues={{ search: "" }}>
                                <Form id="filterForm">
                                    <Field name="filter">
                                        {({ field, form }) => (
                                            <FormControl>
                                                <SimpleGrid columns={12}>
                                                    <GridItem colSpan={{ base: 12, md: 10 }}>
                                                        <Input {...field} mb={{ base: 2, md: 0 }} borderRightRadius={{ base: 10, md: 0 }} placeholder="Pesquisar por..." borderRadius="10px" fontSize="sm" size="md" pr='4.5rem' />
                                                    </GridItem>
                                                    <GridItem colSpan={{ base: 12, md: 2 }}>
                                                        <Button colorScheme="blue" size='md' borderLeftRadius={{ base: 15, md: 0 }} type="submit" w="100%" leftIcon={<FaSearch />}>
                                                            Buscar
                                                        </Button>
                                                    </GridItem>
                                                </SimpleGrid>
                                            </FormControl>
                                        )}
                                    </Field>
                                </Form>
                            </Formik>
                        </Flex>
                        <Flex direction="column" w="100%">
                            <Flex direction="column" w="100%" overflowX={"auto"}>
                                <Table>
                                    <Thead>
                                        <Tr>
                                            <Th>ID</Th>
                                            <Th>Provedor</Th>
                                            <Th>Identificador</Th>
                                            <Th>Cidade</Th>
                                            <Th>Estado</Th>
                                            <Th>Ações</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {data.data && data.data.length ?
                                            data.data.map((station) => (
                                                <StationRow
                                                    key={station.id}
                                                    station={station}
                                                    getData={getData}
                                                />
                                            ))
                                            :
                                            (
                                                <Tr>
                                                    <Td colSpan={5} textAlign={"center"} color="gray.500">Nenhuma estação encontrada</Td>
                                                </Tr>
                                            )
                                        }
                                    </Tbody>
                                </Table>
                            </Flex>
                            <Pagination changePage={getData} data={data} nextButtonText="Próxima" prevButtonText="Anterior" />
                            <Flex w={"100%"} justify="center" fontSize="sm" color="gray.500">
                                {
                                    data?.meta?.total ?
                                        (
                                            data.meta.filter ?
                                                <Text>{data.meta.total} registros encontradas para "{data.meta.filter}", mostrando de {data.meta.from} a {data.meta.to}</Text>
                                                :
                                                <Text>
                                                    Mostrando de {data.meta.from} a {data.meta.to} de {data.meta.total} registros
                                                </Text>
                                        )
                                        :
                                        ""
                                }
                            </Flex>
                        </Flex>
                    </Flex>
                </Box>
            </Box>


            <StationFormDrawer isOpen={createClosure.isOpen} onClose={createClosure.onClose} station={{}} getData={getData} />
        </>
    );
}

function StationRow({ station, getData }) {
    const logsClosure = useDisclosure();
    const normalRainClosure = useDisclosure();
    const dataClosure = useDisclosure();
    const restoreClosure = useDisclosure();
    const editClosure = useDisclosure();
    const deleteClosure = useDisclosure();

    return (
        <Tr>
            <Td>{station.id}</Td>
            <Td>{station.provider}</Td>
            <Td>
                {station.identifier}
                <br />
                {
                    !station.show_homepage ?
                        <>
                            <Text color="red" fontWeight={"semibold"} fontStyle="italic" fontSize={"xs"}>Escondida</Text>
                        </>
                        :
                        ''
                }
                <i>{station.description}</i>
            </Td>
            <Td>{station.city}</Td>
            <Td>{station.state}</Td>
            <Td textAlign={"center"}>
                <Flex gridGap={2} flexWrap={"wrap"} justify={"center"}>
                    {["Wunderground", "INMET", "EcoWitt"].indexOf(station.provider) !== -1 &&
                        <Button variant="outline" colorScheme="blue" size="sm" onClick={restoreClosure.onOpen} leftIcon={<FaHistory />}>
                            Restaurar
                        </Button>
                    }

                    <Button variant="outline" colorScheme="gray" size="sm" onClick={editClosure.onOpen} leftIcon={<FaPencilAlt />}>
                        Editar
                    </Button>

                    <Button variant="outline" colorScheme="purple" size="sm" onClick={normalRainClosure.onOpen} leftIcon={<FaTable />}>
                        Média Chuva
                    </Button>

                    {["Lora"].indexOf(station.provider) !== -1 &&
                        <Button variant="outline" colorScheme="green" size="sm" onClick={logsClosure.onOpen} leftIcon={<FaList />}>
                            Logs
                        </Button>
                    }

                    <Button as="a" href={`/estacao/${station.id}`} target="_blank" variant="outline" colorScheme="teal" size="sm" leftIcon={<FaExternalLinkAlt />}>
                        Detalhes
                    </Button>

                    <Button as="a" href={`/members/reports/detailed?station=${station.id}`} target="_blank" variant="outline" colorScheme="orange" size="sm" leftIcon={<FaChartLine />}>
                        Relatório
                    </Button>

                    <Button variant="outline" colorScheme="pink" size="sm" onClick={dataClosure.onOpen} leftIcon={<FaDatabase />}>
                        Dados
                    </Button>

                    <Button variant="outline" colorScheme="red" size="sm" onClick={deleteClosure.onOpen} leftIcon={<FaTrashAlt />}>
                        Excluir
                    </Button>
                </Flex>

                <>
                    <StationFormDrawer isOpen={editClosure.isOpen} onClose={editClosure.onClose} station={station} getData={getData} />

                    <DeleteStation station={station} isOpen={deleteClosure.isOpen} onClose={deleteClosure.onClose} getData={getData} />
                    <RestoreDataStation station={station} isOpen={restoreClosure.isOpen} onClose={restoreClosure.onClose} getData={getData} />
                    <StationNormalRainDrawer isOpen={normalRainClosure.isOpen} onClose={normalRainClosure.onClose} station={station} getData={getData} />
                    <StationLogs station={station} isOpen={logsClosure.isOpen} onClose={logsClosure.onClose} />
                    <StationData station={station} isOpen={dataClosure.isOpen} onClose={dataClosure.onClose} />
                </>
            </Td>
        </Tr>
    );
}

function StationLogs({ station, isOpen, onClose }) {
    const loading = useLoading();

    const [page, setPage] = useState(1);
    const [data, setData] = useState({});
    const [filter, setFilter] = useState('');

    const getData = async (param) => {
        loading.show();
        let currentPage = param ? param.page : (page || 1);
        setPage(currentPage);
        let response = await StationsApi.logs(station.id, currentPage, filter);
        setData(response.json);
        loading.hide();
    }

    useEffect(() => {
        if (isOpen && station.id)
            getData({ page: 1 });
    }, [station, isOpen]);

    const onFilterSubmit = (formData) => {
        loading.show();
        setPage(1);
        setFilter(formData.filter);
        setTimeout(() => {
            getData();
        }, 400);
    }

    const theme = useColorModeValue("rjv-default", "monokai");

    return (
        <AlertDialog isOpen={isOpen} onClose={onClose} size="6xl">
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        Logs da Estação
                        <Text fontSize={"sm"} opacity={.75} fontWeight={"semibold"}>{station.identifier} - {station.city}/{station.state}</Text>
                    </AlertDialogHeader>

                    <AlertDialogBody>

                        <Flex direction="column" w="100%">
                            <Flex direction="column" w="100%" overflowX={"auto"} mb={4}>
                                <Formik onSubmit={onFilterSubmit} initialValues={{ search: "" }}>
                                    <Form id="filterForm">
                                        <Field name="filter">
                                            {({ field }) => (
                                                <FormControl>
                                                    <SimpleGrid columns={12}>
                                                        <GridItem colSpan={{ base: 12, md: 10 }}>
                                                            <Input {...field} mb={{ base: 2, md: 0 }} borderRightRadius={{ base: 10, md: 0 }} placeholder="Pesquisar por..." borderRadius="10px" fontSize="sm" size="md" pr='4.5rem' />
                                                        </GridItem>
                                                        <GridItem colSpan={{ base: 12, md: 2 }}>
                                                            <Button size='md' borderLeftRadius={{ base: 15, md: 0 }} type="submit" w="100%" leftIcon={<FaSearch />}>
                                                                Buscar
                                                            </Button>
                                                        </GridItem>
                                                    </SimpleGrid>
                                                </FormControl>
                                            )}
                                        </Field>
                                    </Form>
                                </Formik>
                            </Flex>
                            <Flex direction="column" w="100%">
                                <Flex direction="column" w="100%" overflowX={"auto"}>
                                    <Table>
                                        <Thead>
                                            <Tr>
                                                <Th>Dados</Th>
                                                <Th>Momento</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {data.data && data.data.length ?
                                                data.data.map((stationLog) => (
                                                    <Tr key={stationLog.id}>
                                                        <Td>
                                                            <ReactJson src={JSON.parse(stationLog.data)} collapsed={2} theme={theme} />
                                                        </Td>
                                                        <Td>{stationLog.created_at}</Td>
                                                    </Tr>
                                                ))
                                                :
                                                (
                                                    <Tr>
                                                        <Td colSpan={2} textAlign={"center"} color="gray.500">Nenhum log encontrado</Td>
                                                    </Tr>
                                                )
                                            }
                                        </Tbody>
                                    </Table>
                                </Flex>
                                <Pagination changePage={getData} data={data} nextButtonText="Próxima" prevButtonText="Anterior" />
                                <Flex w={"100%"} justify="center" fontSize="sm" color="gray.500">
                                    {
                                        data?.meta?.total ?
                                            (
                                                data.meta.filter ?
                                                    <Text>{data.meta.total} registros encontradas para "{data.meta.filter}", mostrando de {data.meta.from} a {data.meta.to}</Text>
                                                    :
                                                    <Text>
                                                        Mostrando de {data.meta.from} a {data.meta.to} de {data.meta.total} registros
                                                    </Text>
                                            )
                                            :
                                            ""
                                    }
                                </Flex>
                            </Flex>
                        </Flex>

                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button onClick={onClose}>
                            Cancelar
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

function RestoreDataStation({ station, isOpen, onClose, getData }) {
    const loading = useLoading();
    const toast = useToast({
        position: "top-right"
    });
    async function onSubmit(formData, { setFieldError }) {
        loading.show();
        let response = await StationsApi.restore(station.id, formData);
        loading.hide();
        if (response.status == 200) {
            toast({ status: 'success', title: 'Restauração adicionada na fila de processamento!', duration: 3000, variant: 'solid', isClosable: true });
            onClose();
            getData();
        } else if (response.status === 422) {
            let errors = response.json.errors;
            for (let field in errors) {
                setFieldError(field, errors[field][0]);
            }
        } else {
            toast({ status: 'error', title: 'Houve um problema ao iniciar restauração! Cód. ' + response.status, duration: 3000, variant: 'solid', isClosable: true });
        }
    };

    return (
        <AlertDialog isOpen={isOpen} onClose={onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        Restaurar Dados da Estação
                        <Text fontSize={"sm"} opacity={.75} fontWeight={"semibold"}>{station.identifier} - {station.city}/{station.state}</Text>
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        <Formik onSubmit={onSubmit} initialValues={{ from: "", to: "" }}>
                            <Form id="restoreData">
                                <SimpleGrid columns={{ sm: 1, lg: 2 }} gap={4}>
                                    <GridItem colSpan={2}>
                                        <Alert status="info" borderRadius={10} fontSize={"sm"}>
                                            <AlertIcon />
                                            <AlertDescription>Somente disponível para estações Wundergound e INMET</AlertDescription>
                                        </Alert>
                                    </GridItem>
                                    <Field name="from">
                                        {({ field, form }) => (
                                            <FormControl isInvalid={form.errors.from && form.touched.from} isRequired>
                                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                                    À partir de:
                                                </FormLabel>
                                                <Input {...field} type="date" borderRadius="10px" fontSize="sm" size="md" />
                                                <FormErrorMessage>{form.errors.from}</FormErrorMessage>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name="to">
                                        {({ field, form }) => (
                                            <FormControl isInvalid={form.errors.to && form.touched.to} isRequired>
                                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                                    Até:
                                                </FormLabel>
                                                <Input {...field} type="date" borderRadius="10px" fontSize="sm" size="md" />
                                                <FormErrorMessage>{form.errors.to}</FormErrorMessage>
                                            </FormControl>
                                        )}
                                    </Field>
                                </SimpleGrid>
                            </Form>
                        </Formik>
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button onClick={onClose}>
                            Cancelar
                        </Button>
                        <Button type='submit' form='restoreData' colorScheme='blue' ml={3}>
                            Restaurar
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

function DeleteStation({ station, isOpen, onClose, getData }) {
    const cancelRef = useRef();
    const toast = useToast({
        position: "top-right"
    });
    const onDelete = async () => {
        let response = await StationsApi.delete(station.id);
        if (response.status == 204) {
            toast({ status: 'success', title: 'Estação excluído com sucesso!', duration: 3000, variant: 'solid', isClosable: true });
            onClose();
            getData();
        } else {
            toast({ status: 'error', title: 'Houve um problema ao excluir a estação! Cód. ' + response.status, duration: 3000, variant: 'solid', isClosable: true });
        }
    };

    return (
        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        Excluir Estação
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        Você tem certeza que deseja excluir a estação: <b>{station.identifier}</b>?
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose}>
                            Não, Cancelar
                        </Button>
                        <Button colorScheme='red' onClick={onDelete} ml={3}>
                            Sim, Excluir
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

function ExistingKeyPicker({ label, optionsKey, onSelect }) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    // null = loading, 'error' = failed to load, array = loaded
    const [options, setOptions] = useState(null);
    const modalBg = useColorModeValue("white", "gray.700");

    const load = async () => {
        setOptions(null);
        try {
            const res = await StationsApi.keyOptions();
            if (res.status === 200) {
                setOptions(res.json?.[optionsKey] ?? []);
                return;
            }
        } catch (e) {
            // Client throws on non-2xx; fall through to the error state below.
        }
        setOptions('error');
    };

    const open = () => {
        onOpen();
        load();
    };

    return (
        <>
            <IconButton
                aria-label={`Escolher ${label} em uso`}
                title="Escolher entre as chaves em uso"
                icon={<FaList />}
                size="sm"
                variant="ghost"
                onClick={open}
            />
            <Modal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent bg={modalBg}>
                    <ModalHeader fontSize="md">Chaves em uso — {label}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        {options === null ? (
                            <Flex justify="center" py={6}><Spinner /></Flex>
                        ) : options === 'error' ? (
                            <VStack py={4} spacing={3}>
                                <Text fontSize="sm" color="red.500">Erro ao carregar as chaves em uso.</Text>
                                <Button size="sm" onClick={load}>Tentar novamente</Button>
                            </VStack>
                        ) : options.length === 0 ? (
                            <Text fontSize="sm" color="gray.500">Nenhuma chave em uso encontrada.</Text>
                        ) : (
                            <Table size="sm">
                                <Thead>
                                    <Tr>
                                        <Th>Chave</Th>
                                        <Th isNumeric>Estações</Th>
                                        <Th w="1%"></Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {options.map((option) => (
                                        <Tr key={option.value}>
                                            <Td><Code fontSize="xs" wordBreak="break-all">{option.value}</Code></Td>
                                            <Td isNumeric><Badge colorScheme="green">{option.count}</Badge></Td>
                                            <Td>
                                                <Button size="sm" colorScheme="green" onClick={() => { onSelect(option.value); onClose(); }}>
                                                    Usar
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
}

const ExtraFieldsConfig = forwardRef(function ExtraFieldsConfig({ station }, ref) {
    const toast = useToast({ position: "top-right" });
    const [savedFields, setSavedFields] = useState([]);
    const [selectedFields, setSelectedFields] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    const borderColor = useColorModeValue("gray.200", "gray.600");
    const cardBg = useColorModeValue("gray.50", "gray.700");

    useEffect(() => {
        if (station.id) {
            loadSavedFields();
        }
    }, [station.id]);

    const loadSavedFields = async () => {
        try {
            const res = await StationsApi.getExtraFields(station.id);
            if (res.status === 200 && res.json) {
                setSavedFields(res.json);
                setSelectedFields(res.json.map(f => ({
                    field_path: f.field_path,
                    name: f.name,
                    unit: f.unit,
                    selected: true,
                    value: null,
                })));
            }
        } catch (e) {
            toast({ status: 'error', title: 'Erro ao carregar sensores extras.', duration: 3000, variant: 'solid', isClosable: true });
        }
    };

    const getSelectedFields = () => {
        return selectedFields
            .filter(f => f.selected)
            .map((f, idx) => ({
                field_path: f.field_path,
                name: f.name,
                unit: f.unit,
                sort_order: idx,
            }));
    };

    const setDiscoveredFields = (apiFields) => {
        if (!apiFields || !apiFields.length) return;
        setHasFetched(true);
        const merged = apiFields.map(af => {
            const saved = savedFields.find(sf => sf.field_path === af.field_path);
            return {
                field_path: af.field_path,
                name: saved ? saved.name : formatFieldName(af.field_path),
                unit: saved ? saved.unit : af.unit,
                value: af.value,
                selected: !!saved,
            };
        });
        setSelectedFields(merged);
    };

    // Expose methods to parent via ref
    useImperativeHandle(ref, () => ({
        getSelectedFields,
        setDiscoveredFields,
    }), [selectedFields, savedFields]);

    const formatFieldName = (fieldPath) => {
        return fieldPath
            .replace(/_/g, ' ')
            .replace(/\./g, ' - ')
            .replace(/ch(\d+)/g, 'Canal $1')
            .replace(/\b\w/g, c => c.toUpperCase());
    };

    const toggleField = (fieldPath) => {
        setSelectedFields(prev => prev.map(f =>
            f.field_path === fieldPath ? { ...f, selected: !f.selected } : f
        ));
    };

    const updateFieldName = (fieldPath, name) => {
        setSelectedFields(prev => prev.map(f =>
            f.field_path === fieldPath ? { ...f, name } : f
        ));
    };

    const updateFieldUnit = (fieldPath, unit) => {
        setSelectedFields(prev => prev.map(f =>
            f.field_path === fieldPath ? { ...f, unit } : f
        ));
    };

    const selectedCount = selectedFields.filter(f => f.selected).length;

    if (!hasFetched && savedFields.length === 0) return null;

    return (
        <Box mt={6}>
            <Divider mb={4} />
            <HStack mb={3}>
                <Heading size="sm">Sensores Extras</Heading>
                {savedFields.length > 0 && !hasFetched && <Badge colorScheme="green">{savedFields.length} configurados</Badge>}
            </HStack>

            {!hasFetched && savedFields.length > 0 && (
                <VStack spacing={2} align="stretch">
                    {savedFields.map(f => (
                        <HStack key={f.field_path} p={2} bg={cardBg} borderRadius="md" border="1px solid" borderColor={borderColor}>
                            <Badge colorScheme="green" fontSize="xs" textTransform="none">{f.field_path}</Badge>
                            <Text fontSize="sm" flex={1}>{f.name}</Text>
                            <Badge>{f.unit}</Badge>
                        </HStack>
                    ))}
                </VStack>
            )}

            {hasFetched && selectedFields.length > 0 && (
                <VStack spacing={3} align="stretch">
                    {selectedFields.map(f => (
                        <Box key={f.field_path} p={3} bg={cardBg} borderRadius="10px" border="1px solid" borderColor={f.selected ? "green.300" : borderColor}>
                            <Flex align="center" gap={2} mb={f.selected ? 2 : 0}>
                                <Checkbox isChecked={f.selected} onChange={() => toggleField(f.field_path)} colorScheme="green" />
                                <Badge colorScheme="green" fontSize="xs" textTransform="none">{f.field_path}</Badge>
                                {f.value != null && <Text fontSize="xs" color="gray.500">Atual: {f.value} {f.unit}</Text>}
                            </Flex>
                            {f.selected && (
                                <SimpleGrid columns={2} gap={4}>
                                    <FormControl>
                                        <FormLabel mb="0" fontSize="sm" fontWeight="normal">Nome:</FormLabel>
                                        <Input value={f.name} onChange={e => updateFieldName(f.field_path, e.target.value)} borderRadius="10px" fontSize="md" size="md" />
                                    </FormControl>
                                    <FormControl>
                                        <FormLabel mb="0" fontSize="sm" fontWeight="normal">Unidade:</FormLabel>
                                        <Input value={f.unit} onChange={e => updateFieldUnit(f.field_path, e.target.value)} borderRadius="10px" fontSize="md" size="md" />
                                    </FormControl>
                                </SimpleGrid>
                            )}
                        </Box>
                    ))}
                </VStack>
            )}

            {hasFetched && selectedFields.length === 0 && (
                <Text fontSize="sm" color="gray.500">Nenhum sensor extra disponível nesta estação.</Text>
            )}
        </Box>
    );
});

function StationFormDrawer({ isOpen, onClose, station, getData }) {
    const loading = useLoading();
    const toast = useToast({
        position: "top-right"
    });

    const submitHandle = async (values) => {
        loading.show();
        let data = null;
        if (station.id) {
            data = await StationsApi.update(station.id, values);
        } else {
            data = await StationsApi.store(values);
        }

        if (data.status >= 200 && data.status < 300) {
            // Save extra fields if the component was rendered (handles both add and remove)
            if (extraFieldsRef.current) {
                const extraFields = extraFieldsRef.current.getSelectedFields();
                const stationId = station.id || data.json?.data?.id;
                if (stationId) {
                    try {
                        await StationsApi.saveExtraFields(stationId, extraFields);
                    } catch (e) {
                        toast({ status: 'warning', title: 'Erro ao salvar sensores extras.', duration: 3000, variant: 'solid', isClosable: true });
                    }
                }
            }

            toast({ status: 'success', title: 'Estação salva com sucesso!', duration: 3000, variant: 'solid', isClosable: true });
            loading.hide();
            getData();
            onClose();
        } else {
            toast({ status: 'error', title: 'Erro ao salvar a estação! Cód. ' + data.status, duration: 3000, variant: 'solid', isClosable: true });
            loading.hide();
        }
    }

    let initialValues = {
        provider: station.provider ? station.provider == "WS Clima" ? "EcoWitt" : station.provider : null,
        identifier: station.identifier || null,
        state: station.state || null,
        city: station.city || null,
        description: station.description || null,
        lat: station.lat ?? 0,
        long: station.long ?? 0,
        elevation: station.elevation || null,
        show_homepage: station.show_homepage,
        app_key: station.app_key || "",
        api_key: station.api_key || ""
    };

    const extraFieldsRef = useRef();

    const [map, setMap] = useState(<Skeleton height={200} />);
    const reloadMap = (form) => {
        setMap(<Skeleton height={200} />);
        setTimeout(() => {
            setMap(<SingleMarkerMap point={[form.values.lat || 0, form.values.long || 0]} text="Localização da Estação" />);
        }, 1000);
    }

    useEffect(() => {
        if (station.id) {
            reloadMap({
                values: {
                    lat: station.lat || 0,
                    long: station.long || 0
                }
            });
        }
    }, [])

    const loadData = async (form) => {
        loading.show();
        let data;
        try {
            data = await StationsApi.search({ identifier: form.values.identifier, provider: form.values.provider, app_key: form.values.app_key, api_key: form.values.api_key });
        } catch (e) {
            // Axios throws on 4xx/5xx; normalize to the {status, json} tuple so
            // provider errors (e.g. EcoWitt credential rejection) reach the
            // branches below and the loading overlay is always dismissed.
            data = { status: e.response?.status ?? 0, json: e.response?.data ?? null };
        }
        if (data.status === 200) {
            let uf = data.json.state.length > 2 ? Helper.ufList().find(uf => uf.full_name === data.json.state).uf || 'null' : data.json.state;
            form.values.lat = data.json.lat;
            form.values.long = data.json.long;
            form.setFieldValue('lat', data.json.lat);
            form.setFieldValue('long', data.json.long);
            form.setFieldValue('elevation', data.json.elev);
            form.setFieldValue('state', uf);
            form.setFieldValue('city', data.json.city);
            form.setFieldValue('description', data.json.description);

            setTimeout(() => {
                reloadMap(form);
            }, 500)
        } else if (data.status === 204) {
            toast({ status: 'warning', title: 'Nenhum dado retornado, identificador inválido/estação desligada!', duration: 3000, variant: 'solid', isClosable: true });
        } else if (data.json?.message) {
            // Provider rejected the request (e.g. invalid EcoWitt credentials):
            // show the specific reason returned by the backend.
            toast({ status: 'error', title: data.json.message, duration: 6000, variant: 'solid', isClosable: true });
        } else {
            toast({ status: 'error', title: 'Erro ao buscar estação! Cód. ' + data.status, duration: 3000, variant: 'solid', isClosable: true });
        }

        // Set extra fields from the search response (EcoWitt only)
        if (data.status === 200 && data.json?.extra_fields) {
            extraFieldsRef.current?.setDiscoveredFields(data.json.extra_fields);
        }

        loading.hide();
    }


    const drawerBgColor = useColorModeValue("white", "gray.700")

    return (
        <Drawer isOpen={isOpen} onClose={onClose} size="md">
            <DrawerOverlay backdropFilter="blur(4px)" />
            <DrawerContent bg={drawerBgColor}>
                <DrawerCloseButton />
                <Box bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)" py={4} px={6} mb={4}>
                    <Flex align="center" gap={3}>
                        <Flex align="center" justify="center" bg="whiteAlpha.200" borderRadius="lg" p={2}>
                            <Icon as={TbAntenna} color="white" boxSize={5} />
                        </Flex>
                        <Text color="white" fontWeight="bold" fontSize="lg">{station.id ? 'Editar' : 'Nova'} Estação</Text>
                    </Flex>
                </Box>
                <DrawerBody>

                    <Formik onSubmit={submitHandle} initialValues={initialValues} enableReinitialize={true}>
                        {props => (
                            <Form id="stationForm">
                                <Flex flexDirection="row" flexWrap w="100%">
                                    <SimpleGrid w="100%" columns={12} gap={4}>
                                        <GridItem colSpan={5}>
                                            <Field name="provider">
                                                {({ field, form }) => (
                                                    <FormControl isRequired={!station.id} isDisabled={!!station.id}>
                                                        <FormLabel mb="0" htmlFor="provider" fontWeight="normal">Provedor:</FormLabel>
                                                        <Select id="provider" {...field} borderRadius="10px" fontSize="md" placeholder="Selecione...">
                                                            <option value="Wunderground">Wunderground</option>
                                                            <option value="INMET">INMET</option>
                                                            <option value="WeatherLink">WeatherLink</option>
                                                            <option value="AmbientWeather">AmbientWeather</option>
                                                            <option value="EcoWitt">EcoWitt (WS Clima)</option>
                                                            <option value="Lora">Lora (Passivo)</option>
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>
                                        <GridItem colSpan={5}>
                                            <Field name="identifier">
                                                {({ field, form }) => (
                                                    <FormControl isRequired={!station.id} isDisabled={!!station.id}>
                                                        <FormLabel mb="0" htmlFor="identifier" whiteSpace={"nowrap"} fontWeight="normal">Identificador:</FormLabel>
                                                        <Input id="identifier" {...field} borderRadius="10px" fontSize="md" type="text" placeholder="IESTACAO2" />
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>

                                        <GridItem colSpan={2}>
                                            <IconButton colorScheme={"blue"} w="100%" mt={6} onClick={() => loadData(props)} icon={<FaSearch />} />
                                        </GridItem>


                                        <GridItem colSpan={9}>
                                            <Field name="city">
                                                {({ field, form }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel mb="0" htmlFor="city" fontWeight="normal">Cidade:</FormLabel>
                                                        <Input id="city" {...field} borderRadius="10px" fontSize="md" type="text" placeholder="Porto Alegre" />
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>
                                        <GridItem colSpan={3}>
                                            <Field name="state">
                                                {({ field, form }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel mb="0" htmlFor="state" fontWeight="normal">UF:</FormLabel>
                                                        <Select id="state" {...field} borderRadius="10px" fontSize="md" placeholder="Selecione...">
                                                            {Helper.ufList().map(uf => <option key={uf.uf} value={uf.uf}>{uf.uf}</option>)}
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>

                                        <GridItem colSpan={{ sm: 6, lg: 4 }}>
                                            <Field name="lat">
                                                {({ field, form }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel mb="0" htmlFor="lat" fontWeight="normal">Latitude:</FormLabel>
                                                        <Input id="lat" {...field} borderRadius="10px" fontSize="md" type="text" onBlur={(e) => { reloadMap(form); form.handleBlur(e); }} />
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>
                                        <GridItem colSpan={{ sm: 6, lg: 4 }}>
                                            <Field name="long">
                                                {({ field, form }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel mb="0" htmlFor="long" fontWeight="normal">Longitude:</FormLabel>
                                                        <Input id="long" {...field} borderRadius="10px" fontSize="md" type="text" onBlur={(e) => { reloadMap(form); form.handleBlur(e); }} />
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>
                                        <GridItem colSpan={{ sm: 12, lg: 4 }}>
                                            <Field name="elevation">
                                                {({ field, form }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel mb="0" htmlFor="long" fontWeight="normal">Elevação (m):</FormLabel>
                                                        <Input id="elevation" {...field} borderRadius="10px" fontSize="md" />
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>


                                        <GridItem colSpan={12}>
                                            <Field name="description">
                                                {({ field, form }) => (
                                                    <FormControl>
                                                        <FormLabel mb="0" htmlFor="description" fontWeight="normal">Descrição Adicional:</FormLabel>
                                                        <Input id="description" {...field} borderRadius="10px" fontSize="md" />
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>

                                        <GridItem colSpan={12}>
                                            <Field name="show_homepage">
                                                {({ field, form }) => (
                                                    <FormControl>
                                                        <FormLabel mb="0" htmlFor="show_homepage" fontWeight="normal">Exibir na tela inicial:</FormLabel>
                                                        <Select id="show_homepage" {...field} borderRadius="10px" fontSize="md" defaultValue={'true'} placeholder="Selecione...">
                                                            <option value="true">Sim</option>
                                                            <option value="false">Não</option>
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>

                                        <GridItem colSpan={12}>
                                            {(props.values.lat != 0 && props.values.long != 0 && map) || <Skeleton height={200} />}
                                        </GridItem>

                                        {props.values.provider === "EcoWitt" && (
                                            <GridItem colSpan={12}>
                                                <Field name="app_key">
                                                    {({ field, form }) => (
                                                        <FormControl>
                                                            <FormLabel mb="0" htmlFor="app_key" fontWeight="normal">Ecowitt Application Key (opcional):</FormLabel>
                                                            <InputGroup>
                                                                <Input id="app_key" {...field} borderRadius="10px" fontSize="md" type="text" placeholder="Padrão do sistema" pr="3rem" />
                                                                <InputRightElement>
                                                                    <ExistingKeyPicker label="Application Key" optionsKey="app_keys" onSelect={(value) => form.setFieldValue('app_key', value)} />
                                                                </InputRightElement>
                                                            </InputGroup>
                                                            <FormHelperText fontSize="xs">Deixe em branco para usar a Application Key padrão do sistema.</FormHelperText>
                                                        </FormControl>
                                                    )}
                                                </Field>
                                            </GridItem>
                                        )}

                                        {props.values.provider === "EcoWitt" && (
                                            <GridItem colSpan={12}>
                                                <Field name="api_key">
                                                    {({ field, form }) => (
                                                        <FormControl>
                                                            <FormLabel mb="0" htmlFor="api_key" fontWeight="normal">Ecowitt API Key (opcional):</FormLabel>
                                                            <InputGroup>
                                                                <Input id="api_key" {...field} borderRadius="10px" fontSize="md" type="text" placeholder="Padrão do sistema" pr="3rem" />
                                                                <InputRightElement>
                                                                    <ExistingKeyPicker label="API Key" optionsKey="api_keys" onSelect={(value) => form.setFieldValue('api_key', value)} />
                                                                </InputRightElement>
                                                            </InputGroup>
                                                            <FormHelperText fontSize="xs">Deixe em branco para usar a API Key padrão do sistema.</FormHelperText>
                                                        </FormControl>
                                                    )}
                                                </Field>
                                            </GridItem>
                                        )}

                                        {props.values.provider === "EcoWitt" && (
                                            <GridItem colSpan={12}>
                                                <ExtraFieldsConfig ref={extraFieldsRef} station={station} />
                                            </GridItem>
                                        )}

                                    </SimpleGrid>
                                </Flex>
                            </Form>
                        )}
                    </Formik>


                </DrawerBody>
                <DrawerFooter>
                    <Button variant='outline' mr={3} onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button type='submit' form='stationForm' colorScheme="whatsapp">
                        Salvar
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
}

function StationNormalRainDrawer({ isOpen, onClose, station, getData }) {
    const loading = useLoading();
    const toast = useToast({
        position: "top-right"
    });
    const drawerBgColor = useColorModeValue("white", "gray.700");

    const submitHandle = async (values) => {
        loading.show();
        let data = await StationsApi.store_rain_data(station.id, values);

        if (data.status >= 200 && data.status < 300) {
            toast({ status: 'success', title: data.json.message, duration: 3000, variant: 'solid', isClosable: true });
            loading.hide();
            getData();
            onClose();
        } else {
            toast({ status: 'error', title: 'Erro ao salvar dados! Cód. ' + data.status, duration: 6000, variant: 'solid', isClosable: true });
            loading.hide();
        }
    }

    let initialValues = {
        jan: station?.normal_rain?.jan || 0,
        feb: station?.normal_rain?.feb || 0,
        mar: station?.normal_rain?.mar || 0,
        apr: station?.normal_rain?.apr || 0,
        may: station?.normal_rain?.may || 0,
        jun: station?.normal_rain?.jun || 0,
        jul: station?.normal_rain?.jul || 0,
        aug: station?.normal_rain?.aug || 0,
        sep: station?.normal_rain?.sep || 0,
        oct: station?.normal_rain?.oct || 0,
        nov: station?.normal_rain?.nov || 0,
        dec: station?.normal_rain?.dec || 0,
        copy: '1'
    };

    let keys = Object.keys(initialValues);
    keys.pop();

    function translateMonthName(number) {
        switch (number) {
            case 'jan': return 'Janeiro';
            case 'feb': return 'Fevereiro';
            case 'mar': return 'Março';
            case 'apr': return 'Abril';
            case 'may': return 'Maio';
            case 'jun': return 'Junho';
            case 'jul': return 'Julho';
            case 'aug': return 'Agosto';
            case 'sep': return 'Setembro';
            case 'oct': return 'Outubro';
            case 'nov': return 'Novembro';
            case 'dec': return 'Dezembro';
        }
    }

    return (
        <Drawer isOpen={isOpen} onClose={onClose} size="lg">
            <DrawerOverlay backdropFilter="blur(4px)" />
            <DrawerContent bg={drawerBgColor}>
                <DrawerCloseButton />
                <Box bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)" py={4} px={6} mb={4}>
                    <Flex direction="column">
                        <Text color="white" fontWeight="bold" fontSize="lg">Precipitação Normal da Estação (mm)</Text>
                        <Text color="whiteAlpha.800" fontSize="sm">{station.provider} - {station.identifier}</Text>
                    </Flex>
                </Box>
                <DrawerBody>

                    <Formik onSubmit={submitHandle} initialValues={initialValues} enableReinitialize={true}>
                        {props => (
                            <Form id="stationNormalRainForm" key={"stationNormalRainForm"}>
                                <SimpleGrid w="100%" gap={2} columns={{ sm: 1, md: 2, lg: 3 }}>
                                    {
                                        keys.map((month, index) => <GridItem>
                                            <Field name={month} key={index}>
                                                {({ field, form }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel mb="0" htmlFor={month} whiteSpace={"nowrap"} fontWeight="normal">{(index + 1).toString().padStart(2, '0')} - {translateMonthName(month)}:</FormLabel>
                                                        <Input
                                                            id={month}
                                                            {...field}
                                                            borderRadius="10px"
                                                            fontSize="md"
                                                            type="number"
                                                            step="0.01"
                                                        />
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </GridItem>
                                        )
                                    }
                                </SimpleGrid>
                                <Field name={`copy`}>
                                    {({ field, form }) => (
                                        <FormControl isRequired mt={4}>
                                            <FormLabel mb="0" htmlFor={`replicate`} whiteSpace={"nowrap"} fontWeight="normal">Replicar dados para mesma cidade?</FormLabel>
                                            <Select id="copy" {...field} borderRadius="10px" fontSize="md" placeholder="Selecione...">
                                                <option value="0">Não</option>
                                                <option value="1">Sim, copiar</option>
                                            </Select>
                                            <FormHelperText fontSize={"xs"}>
                                                Selecione "Sim, copiar" para replicar os dados para todas as estações num raio de 50km.
                                            </FormHelperText>
                                        </FormControl>
                                    )}
                                </Field>
                            </Form>
                        )}
                    </Formik>


                </DrawerBody>
                <DrawerFooter>
                    <Button variant='outline' mr={3} onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button type='submit' form='stationNormalRainForm' colorScheme="whatsapp">
                        Salvar
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
}


export function StationData({ station, isOpen, onClose, canEdit = true }) {
    const bgColor = useColorModeValue("white", "gray.800");

    return (
        <AlertDialog isOpen={isOpen} onClose={onClose} size="full">
            <AlertDialogOverlay>
                <AlertDialogContent bg={bgColor}>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        Dados da Estação
                        <Text fontSize={"sm"} opacity={.75} fontWeight={"semibold"}>{station.full_name}</Text>
                        <AlertDialogCloseButton />
                    </AlertDialogHeader>

                    <AlertDialogBody>

                        <StationDataBody stationId={station.id} canEdit={canEdit} />

                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button onClick={onClose}>
                            Fechar
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

export function StationDataBody({ stationId, canEdit, defaultDay = '', isEmbeded = false }) {
    const loading = useLoading();
    const toast = useToast({
        position: "top-right"
    });

    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(defaultDay || moment().format('YYYY-MM-DD'));

    const getData = useCallback(async (param) => {
        loading.show();
        setData([]);
        let currentPage = param?.page ? param.page : (page || 1);
        setPage(currentPage);
        let response = await StationsApi.data(stationId, currentPage, defaultDay || param?.filter || filter);
        setData(response.json);
        setTimeout(() => {
            loading.hide();
        }, 500);
    }, [stationId, filter, defaultDay]);

    useEffect(() => {
        if (!stationId) return;

        getData();

        return () => {
            setPage(1);
            setFilter('');
            setData([]);
        }
    }, [defaultDay, stationId]);

    const onFilterSubmit = useCallback(() => {
        loading.show();

        getData({
            page: 1,
            filter: filter
        });
    }, [filter]);

    async function saveDataChanges(data) {
        if (!canEdit) return;

        loading.show();

        let response = await StationsApi.saveData(stationId, data);

        if (response.status === 200) {
            toast({ status: 'success', title: 'Dados salvos com sucesso!', duration: 3000, variant: 'solid', isClosable: true });
        } else {
            toast({ status: 'error', title: 'Erro ao salvar dados! Cód. ' + response.status, duration: 3000, variant: 'solid', isClosable: true });
        }

        loading.hide();
    }

    return (
        <>
            <Flex direction="column" w="100%">
                {!isEmbeded && <Flex direction="column" w="100%" overflowX={"auto"} mb={4}>
                    <SimpleGrid columns={12}>
                        <GridItem colSpan={{ base: 12, md: 10 }}>
                            <Input value={filter} onChange={(e) => setFilter(e.target.value)} type="date" mb={{ base: 2, md: 0 }} borderRightRadius={{ base: 10, md: 0 }} borderRadius="10px" fontSize="sm" size="md" />
                        </GridItem>
                        <GridItem colSpan={{ base: 12, md: 2 }}>
                            <Button colorScheme="blue" size='md' borderLeftRadius={{ base: 15, md: 0 }} type="submit" w="100%" leftIcon={<FaSearch />} onClick={() => onFilterSubmit()}>
                                Buscar
                            </Button>
                        </GridItem>
                    </SimpleGrid>
                </Flex>}

                <Flex direction="column" w="100%">
                    <form onSubmit={(e) => {
                        e.preventDefault();

                        let formData = new FormData(e.target);
                        saveDataChanges(Object.fromEntries(formData));
                    }}>
                        <Flex direction="column" w="100%" overflowX={"auto"}>
                            <Table size="xs" fontSize="sm">
                                <Thead>
                                    <Tr fontSize="xs">
                                        <Th textAlign="center">Temp.</Th>
                                        <Th textAlign="center">Sens. Térm.</Th>
                                        <Th textAlign="center">Pto. Orvalho</Th>
                                        <Th textAlign="center">Índ. Resf. Vento</Th>
                                        <Th textAlign="center">Vel. do Vento</Th>
                                        <Th textAlign="center">Raj. de Vento</Th>
                                        <Th textAlign="center">Dir. Vento</Th>
                                        <Th textAlign="center">Pressão</Th>
                                        <Th textAlign="center">Índ. de Chuva</Th>
                                        <Th textAlign="center">Chuva Acum.</Th>
                                        <Th textAlign="center">Umidade</Th>
                                        <Th textAlign="center">UV</Th>
                                        <Th textAlign="center">Rad. Solar</Th>
                                        <Th textAlign="center">Momento</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {data.data && data.data.length ?
                                        data.data.map((stationData) => (
                                            <Tr key={stationData.id}>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.temp} name={`station_data[${stationData.id}][temp]`} /> : stationData.temp}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.heat_index} name={`station_data[${stationData.id}][heat_index]`} /> : stationData.heat_index}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.dew_point} name={`station_data[${stationData.id}][dew_point]`} /> : stationData.dew_point}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.wind_chill} name={`station_data[${stationData.id}][wind_chill]`} /> : stationData.wind_chill}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.wind_speed} name={`station_data[${stationData.id}][wind_speed]`} /> : stationData.wind_speed}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.wind_gust} name={`station_data[${stationData.id}][wind_gust]`} /> : stationData.wind_gust}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.wind_dir} step={1} name={`station_data[${stationData.id}][wind_dir]`} /> : stationData.wind_dir}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.pressure} name={`station_data[${stationData.id}][pressure]`} /> : stationData.pressure}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.precip_rate} name={`station_data[${stationData.id}][precip_rate]`} /> : stationData.precip_rate}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.precip_total} name={`station_data[${stationData.id}][precip_total]`} /> : stationData.precip_total}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.humidity} step={1} min={0} max={100} name={`station_data[${stationData.id}][humidity]`} /> : stationData.humidity}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.uv} name={`station_data[${stationData.id}][uv]`} /> : stationData.uv}</Td>
                                                <Td textAlign={"center"}>{canEdit ? <Input size="xs" type="number" defaultValue={stationData.solar_radiation} name={`station_data[${stationData.id}][solar_radiation]`} /> : stationData.solar_radiation}</Td>
                                                <Td textAlign="center">{stationData.created_at}</Td>
                                            </Tr>
                                        ))
                                        :
                                        (
                                            <Tr>
                                                <Td colSpan={14} textAlign={"center"} color="gray.500">Nenhum dado encontrado</Td>
                                            </Tr>
                                        )
                                    }
                                </Tbody>
                            </Table>

                            {canEdit &&
                                <Flex justify="center" my={4}>
                                    <Button type="submit" colorScheme="blue" leftIcon={<FaSave />}>Salvar Alterações</Button>
                                </Flex>
                            }

                        </Flex>

                    </form>
                    <Pagination changePage={getData} data={data} nextButtonText="Próxima" prevButtonText="Anterior" />
                    <Flex w={"100%"} justify="center" fontSize="sm" color="gray.500">
                        {
                            data?.meta?.total ?
                                (
                                    data.meta.filter ?
                                        <Text>{data.meta.total} registros encontradas para "{data.meta.filter}", mostrando de {data.meta.from} a {data.meta.to}</Text>
                                        :
                                        <Text>
                                            Mostrando de {data.meta.from} a {data.meta.to} de {data.meta.total} registros
                                        </Text>
                                )
                                :
                                ""
                        }
                    </Flex>
                </Flex>
            </Flex>
        </>
    );
}

export default Stations;
